// Friendly room names as a student should see them: the authored sheets with
// the operator's published overlay (/api/room-names) laid on top — merged by
// the one pure function in roomNameOverlay.js, which the phone mirrors.
//
// Fetched ALONGSIDE the sheets rather than after them, and allowed to fail:
// an overlay that is down costs the published names, never the authored ones.
// Both the pathfinder page and the Event Creator's room search go through
// this, so a name the operator publishes is the same name on both screens.

import { applyRoomNameOverlay } from './roomNameOverlay.js';

export async function fetchRoomNameOverlay(apiBase = '') {
  try {
    const r = await fetch(`${apiBase}/api/room-names`);
    if (!r.ok) return null;
    const j = await r.json();
    const names = j?.names;
    return names && typeof names === 'object' && !Array.isArray(names) ? names : null;
  } catch {
    return null;
  }
}

/** A `loadRoomNames` for a data source: the snapshot's sheets plus the overlay. */
export function liveRoomNames(snapshotSource, apiBase = '') {
  return async () => {
    const [rows, names] = await Promise.all([
      snapshotSource.loadRoomNames ? snapshotSource.loadRoomNames().catch(() => null) : null,
      fetchRoomNameOverlay(apiBase),
    ]);
    return applyRoomNameOverlay(rows, names);
  };
}
